import { t } from '@lingui/core/macro';
import { TGetStateResponseCompanyDE } from 'lendingApi/lapiOverrides.types';

export const DE_LEGAL_FORM_VALUES: {
  label: string;
  value: TGetStateResponseCompanyDE['type'];
}[] = [
  {
    label: 'Freiberufler',
    value: 'freiberufler',
  },
  {
    label: 'Gewerbebetrieb (nicht eingetragene Einzelfirma)',
    value: 'gewerbebetrieb',
  },
  {
    label: 'Eingetragene Einzelfirma',
    value: 'gewerbebetrieb_eingtr',
  },
  {
    label: 'e.K.',
    value: 'ek',
  },
  {
    label: 'Eingetragene Genossenschaft (e.G.)',
    value: 'eg',
  },
  {
    label: 'GbR/BGB-Gesellschaft',
    value: 'gbr',
  },
  {
    label: 'oHG',
    value: 'ohg',
  },
  {
    label: 'KG',
    value: 'kg',
  },
  {
    label: 'Partnerschaft',
    value: 'partnerschaft',
  },
  {
    label: 'Gemeinnütziger Verein e.V.',
    value: 'gemeinnuetziger_verein',
  },
  {
    label: 'Nicht gemeinnütziger Verein',
    value: 'nicht_gemeinnuetziger_verein',
  },
  {
    label: 'UG',
    value: 'ug',
  },
  {
    label: 'GmbH',
    value: 'gmbh',
  },
  {
    label: 'Gmbh & Co. KG',
    value: 'gmbh_u_co_kg',
  },
  {
    label: 'AG',
    value: 'aktiengesellschaft',
  },
  {
    label: 'Ltd. (mit dt. Niederlassung)',
    value: 'ltd',
  },
  {
    label: 'KGaA',
    value: 'kgaa',
  },
  {
    label: 'Andere',
    value: 'andere',
  },
];

export const MONTHS = () => [
  { value: '01', label: t`January` },
  { value: '02', label: t`February` },
  { value: '03', label: t`March` },
  { value: '04', label: t`April` },
  { value: '05', label: t`May` },
  { value: '06', label: t`June` },
  { value: '07', label: t`July` },
  { value: '08', label: t`August` },
  { value: '09', label: t`September` },
  { value: '10', label: t`October` },
  { value: '11', label: t`November` },
  { value: '12', label: t`December` },
];

export const REQUESTED_AMOUNT_CONTACT_THRESHOLD = 350000;
export const REFINANCING_AMOUNT_THRESHOLD = 100000;

export const EMPTY_ADDRESS = {
  house_number: '',
  house_name: '',
  street_line_1: '',
  street_line_2: '',
  town: '',
  postcode: '',
  equifax_token: '',
  residential_status: undefined,
};
